import { createContext } from 'react';

export const defaultState = {
  loading: true,
  devices: [],
  brands: [],
  title: 'Billpay phones',
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'GET_TITLE':
      return state.title;
    case 'loading':
      return { ...state, loading: action.payload };
    case 'set_devices':
      return { ...state, devices: action.payload };
    default:
      break;
  }
};

const Context = createContext();

export default Context;
